import { amountSchema, type Amount } from "../types";
import { z } from "zod";
import { DisplayCategory } from "../enums";

export const cartSkuSchema = z.object({
   cartSkuId: z.number(),
   cartId: z.string(),
   skuId: z.number(),
   productId: z.number(),
   skuName: z.string(),
   userCurrencyAmount: amountSchema,
   skuCurrencyAmount: amountSchema,
   localCurrencyAmount: amountSchema,
   salesTax: z.number(),
   coversSalesTax: z.boolean(),
   recipientCountryCode: z.string(),
   mobileNumber: z.string().optional(),
   giftCardEmail: z.string().optional(),
   internationalCallingCode: z.string().optional(),
   processingFee: z.number(),
   smsFeeSettingValue: z.number().optional(), 
   smsMessage: z.string(),
   operatorId: z.number(),
   displayCategory: z.nativeEnum(DisplayCategory),
});
export type CartSku = z.infer<typeof cartSkuSchema>;
